import React from 'react';

import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import ActionButton from '@src/components/Buttons/ActionButton';
import AuditLogViewer from '@src/components/AuditLogViewer';
import { InfoCardList } from 'components/InfoCard';
import { FSCollections } from '@src/constants/database';

function ExternalCompanyItem({ data, onEdit, onDelete }) {
  const intl = useIntl();

  return (
    <InfoCardList
      key={data.id}
      title={data.name}
      subTitle={data.email}
      extraRightContent={
        <AuditLogViewer
          entityType={FSCollections.COMPANIES}
          entityId={data.id}
          recordLabel={data.name || data.id}
          triggerButton={
            <ActionButton
              icon="history"
              tooltipText={intl.formatMessage({ id: 'general.history.label' })}
            />
          }
        />
      }
      buttonItems={[
        {
          iconName: 'edit',
          action: onEdit,
        },
        {
          iconName: 'delete',
          action: () => onDelete(data.id),
          type: 'danger',
        },
      ]}
    />
  );
}

ExternalCompanyItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    identifier: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
export default React.memo(ExternalCompanyItem);
